// src/pages/PaymentResult.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import successImg from "../images/success.png";
import failureImg from "../images/error.png";
import cancelImg from "../images/error.png";
import Api from "../Api/Api.json";

export default function PaymentResult() {
  const [status, setStatus] = useState(null);
  const [userId, setUserId] = useState(0);

  useEffect(() => {
    const storedInfo = localStorage.getItem("upskill_user_info");
    if (storedInfo !== null) {
      const userInfo = JSON.parse(storedInfo);
      setUserId(userInfo.id);
    }
  }, []);

  useEffect(() => {
    // Check if userId is initialized before making API call
    if (userId === 0) {
      const storedInfo = localStorage.getItem("upskill_user_info");
      if (!storedInfo) {
        alert("দয়া করে প্রথমে লগইন করুন");
        setStatus("failure");
        return;
      }
      // userId will be set by the first useEffect, wait for it
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const paymentID = params.get("paymentID");
    const statusParam = params.get("status");
    const signature = params.get("signature");
    
    if (!paymentID || !statusParam || !signature) {
      setStatus("failure");
      return;
    }

    setStatus(statusParam);
    const body = {
        task: "executePaymentBackendUpskill",
        paymentID: paymentID.toString(),
        status: statusParam.toString(),
        signature: signature.toString(),
        app:"upskill",
        user_id: userId
      };
      console.log(body);

    const headers = { "Content-Type": "application/json" };
        const res = axios.post(Api.BKASH_API, body, { headers })
        .then(response => {
          console.log(response.data);
            if (response.data.status === "success") {
                setStatus("success");
            } else {
                setStatus("failure");
            }
        })
        .catch(err => {
            console.error("Error creating payment:", err);
            setStatus("failure");
        });

  }, [userId]);

  if (!status) return <p>Loading...</p>;

  const image =
    status === "success" ? successImg :
    status === "failure" ? failureImg :
    cancelImg;

  return (
    <div style={{ textAlign: "center" }}>
      <h2>Payment {status}</h2>
      <img src={image} alt={status} style={{ width: "250px" }} />
    </div>
  );
}
